import { render } from "./Certificates.vue?vue&type=template&id=049c5390&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"

import "./Certificates.vue?vue&type=style&index=0&id=049c5390&lang=css"
import "./Certificates.vue?vue&type=style&index=1&id=049c5390&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049c5390"]])

export default __exports__